// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","link":"_1qcS-aRR07R63NUoEtOPgT","container":"_3diOp2Xl6zdIfH9Vlyxci_","title":"_1fVQlTieMMt-4V2gWomx-S","subtitle":"_34ASA-QH4-b_GJr9ZEr2OX"};